var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeslotDropdownClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.881,
    height: 16.266,
    viewBox: "0 0 13.881 16.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timer-svgrepo-com",
    transform: "translate(-37.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90781",
    "data-name": "Group 90781",
    transform: "translate(37.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55862",
    "data-name": "Path 55862",
    d: "M48.8,3.9l.491-.771a.735.735,0,1,0-1.24-.789l-.49.769a6.884,6.884,0,0,0-2.35-.686V1.47h.046a.735.735,0,1,0,0-1.47H43.695a.735.735,0,0,0,0,1.47h.046v.954A6.947,6.947,0,1,0,48.8,3.9ZM47,7.552,45.029,9.809a.735.735,0,0,1-1.107-.966L45.89,6.586A.735.735,0,1,1,47,7.552Z",
    transform: "translate(-37.535)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeslotDropdownClock);
export default __webpack_public_path__ + "static/media/timeslot-dropdown-clock.dd4f83946a97e574c48c96060d14b305.svg";
export { ForwardRef as ReactComponent };